import { useAtsConversationApi } from '@/composables/useApi';
import { useMeStore } from '@/core/shared/me/me.store';

export class ApplicationViewPersistence {
  /**
   * Marks an application as viewed by calling backend API
   * @param applicationId - The ID of the application to mark as viewed
   * @throws Error if API call fails or employerId is not available
   */
  public async markAsViewed(applicationId: number): Promise<void> {
    const meStore = useMeStore();
    const employerId = meStore.employer?.id;

    if (!employerId) {
      throw new Error('No employer selected');
    }

    const url = `conversation/employer/${employerId}/application/${applicationId}/mark-viewed`;

    const { error } = await useAtsConversationApi(url).post();

    if (error.value) {
      throw new Error(error.value);
    }
  }
}
